import sellNowOne from "../assets/sellNowOne.png";
import thrifitLogo from "../assets/thrifit-logo-white.png";
import reviewOne from "../assets/reviewOne.png";
import reviewTwo from "../assets/reviewTwo.png";
import bucketHat from "../assets/bucketHat.png";
import Questions from "../components/frequently-asked-questions/Questions";
import PagePadding from "../layouts/PagePadding";
import { Link } from "react-router-dom";

const SellNow = () => {
  return (
    <div className="-mt-20 bg-lighterGrey overflow-x-hidden">
      <section className="bg-black">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="w-full md:w-1/2 pt-5 pl-5">
            <img src={thrifitLogo} alt="thrifit" />
            <div className="flex flex-col items-center h-auto">
              <h1 className="text-white font-bold h-3/4 lg:leading-64 font-PlayfairDisplay text-2xl lg:text-5xl mt-6 lg:mt-20">
                We have redefined{" "}
                <span className="text-logoRed">convenience</span> to help
                <br /> you stand out
              </h1>
              <Link to="/seller-details">
                <button className="font-medium text-sm self-start lg:self-auto mt-12 bg-lightBlack block w-36 h-10 rounded-xl text-white">
                  Sell Now
                </button>
              </Link>
            </div>
          </div>
          <div className="w-full md:w-1/2 mt-10 md:mt-0">
            <img src={sellNowOne} alt="customers" className="" />
          </div>
        </div>
      </section>

      <section className="relative md:h-[240px] lg:h-[280px]">
        <h1 className="font-bold text-2xl lg:text-5xl pt-20 pl-5">
          Sell anything,
          <br /> from anywhere
        </h1>
        <div className="absolute w-full z-20 hidden md:flex justify-end mt-16 md:mt-0">
            <div className="flex gap-3 mt-20">
              <div className="w-[160px] h-[190px] lg:w-[220px] lg:h-[290px]">
                <img src={reviewOne} alt="review" className="" />
                <p className="text-white block text-left text-sm mt-3">
                  “Lorem ipsum dolor sit amet, consectetur adipiscing elit.”
                </p>
                <p className="text-lightGrey block text-left text-xs font-semibold">
                  Nnenna’s Thrift shop,{" "}
                  <span className="text-logoRed">Seller in Lagos</span>
                </p>
                <div className="flex gap-3 mt-4">
                  <div className="flex justify-center cursor-pointer items-center w-8 h-8 rounded-full bg-lightBlack">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-chevron-left text-white"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                      />
                    </svg>
                  </div>

                  <div className="flex justify-center cursor-pointer items-center w-8 h-8 rounded-full bg-lightBlack">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-chevron-right text-white"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="w-[160px] h-[190px] lg:w-[220px] lg:h-[290px]">
                <img src={reviewTwo} alt="review" className="" />
              </div>

              <div className="w-[160px] h-[190px] lg:w-[220px] lg:h-[290px]">
                <img src={reviewTwo} alt="review" className="" />
              </div>

              <div className="w-[160px] h-[190px] lg:w-[220px] lg:h-[290px]">
                <img src={reviewTwo} alt="review" className="" />
              </div>
            </div>
          </div>
      </section>

      <section className="mt-10">
        <div className="text-white text-center bg-black relative">
          <div className="">
            <h3 className="pt-16 md:pt-[300px] lg:pt-[400px] font-bold text-xl lg:text-5xl mt-20">
              Why Sell on Thrifit
            </h3>

            <h3 className="font-PlayfairDisplay font-thin text-2xl lg:text-5xl pt-20">
              FREE!
            </h3>
            <p className="text-lightGrey mt-5">
              No listing fees, we only make money when you make money
            </p>

            <h3 className="font-PlayfairDisplay font-thin text-2xl lg:text-5xl pt-20">
              Sustainability
            </h3>
            <p className="text-lightGrey mt-5">
              Promoting sustainability in fashion
              <br /> by making fashion circular.
            </p>

            <h3 className="font-PlayfairDisplay font-thin text-2xl lg:text-5xl pt-20">
              Convienience
            </h3>
            <p className="text-lightGrey mt-5 pb-20">
              Manage your inventory and orders easily
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white pb-20">
        <PagePadding>
          <h3 className="text-center text-xl font-bold pt-10">
            Frequently Asked Questions
          </h3>
          <div className="mt-10">
            <Questions
              question="Can i register on thrifit"
              answer="Yes, thrifit is open to everyone and its free"
            />
            <Questions
              question="Can i register on thrifit"
              answer="Yes, thrifit is open to everyone and its free"
            />
            <Questions
              question="Can i register on thrifit"
              answer="Yes, thrifit is open to everyone and its free"
            />
            <Questions
              question="Can i register on thrifit"
              answer="Yes, thrifit is open to everyone and its free"
            />
          </div>
        </PagePadding>
      </section>

      <section className="flex items-center bg-black">
        <div className="w-1/2">
          <img src={bucketHat} alt="thrifit customer" className="w-full" />
        </div>

        <div className="w-1/2 h-full ">
          <h4 className="text-white font-normal font-PlayfairDisplay text-xl lg:text-4xl text-center">
            Sell Today It's easy
          </h4>
          <Link to="/seller-details">
            <button className="font-medium text-sm m-auto mt-4 md:mt-12 bg-logoRed block w-36 h-10 rounded-xl text-white">
              Sell Now
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SellNow;
